import {app} from '../app';

/**
 * The same as ng-click but with lower priority.
 * Therefore, it will be fired after most of the ng-directives, including ng-model.
 */
app.directive('ngDelayedClick', ['$parse', function ($parse) {
        return {
            restrict: 'A',
            priority: -1,
            compile: function($element, $attr) {
                var fn = $parse($attr['ngDelayedClick'], null, true);
                return function ngEventHandler(scope, element) {
                    element.on('click', function(event) {
                        var callback = function() {
                            fn(scope, {$event:event});
                        };

                        scope.$apply(callback);
                    });
                };
            }
        };
}]);